module.exports = __webpack_public_path__ + "static/media/non_ulip.296ef3ed.mp3";